import { createContext, useContext, useState } from "react";

export const dict = {
  en: {
    name: "CALEB DEMISEW ZELEKE",
    role: "PLC PROGRAMMER",
    nav: { about: "ABOUT", skills: "SKILLS", projects: "PROJECTS", contact: "CONTACT", cta: "LET'S TALK" },
    hero: {
      eyebrow: "SYS.STATUS // OPEN TO WORK",
      lines: ["LOGIC THAT", "RUNS", "FACTORIES."],
      sub: "PLC programmer with a diploma in Industrial Automation, specialised in Siemens TIA Portal. Determined and precise — ready to bring logic to life on the factory floor.",
      ctaProjects: "VIEW PROJECTS",
      ctaContact: "CONTACT ME",
      cvBtn: "DOWNLOAD CV",
      fig: "FIG.01 — CONTROL CABINET / COMMISSIONING",
      term: [
        { k: "PLATFORM", v: "TIA PORTAL V17" },
        { k: "CPU", v: "SIMATIC S7-1512C" },
        { k: "STATE", v: "RUN", hot: true },
        { k: "MODE", v: "ON-SITE / REMOTE" },
      ],
      scroll: "SCROLL",
    },
    marquee: ["SIEMENS TIA PORTAL", "LADDER LOGIC", "SCL", "S7-1500", "HMI DESIGN", "PROFINET", "SCADA", "MOTION CONTROL", "WINCC", "COMMISSIONING"],
    about: {
      label: "01 // WHO I AM",
      title: "I SPEAK FLUENT SCL.",
      p1: "I'm an industrial automation technician with a diploma in Electronics and Electrotechnics (Automation track) from I.I.S. Enrico Fermi in Modena. I program PLCs in Siemens TIA Portal — Ladder and SCL — and I got hands-on experience wiring control panels for industrial cranes and testing machine-vision quality systems during my internships.",
      p2: "I'm determined and precise, with a strong will to learn and grow professionally. I like programs the next technician can read: clean block structure, honest comments, diagnostics that actually help.",
      p3: "Open to full-time roles and entry-level positions in industrial automation.",
      cvBtn: "DOWNLOAD CV",
      tags: ["LADDER", "SCL", "HMI", "ELECTRICAL DIAGRAMS", "MACHINE SAFETY", "PROBLEM SOLVING"],
      fig: "FIG.02 — ON SITE",
      status: [
        { k: "SPECIALISATION", v: "SIEMENS TIA PORTAL" },
        { k: "EDUCATION", v: "IIS ENRICO FERMI — MODENA" },
        { k: "CERTIFICATION", v: "ABB ADVANCED PROGRAMMING" },
        { k: "LANGUAGES", v: "IT / EN — C2" },
        { k: "LOCATION", v: "REGGIO EMILIA, IT" },
        { k: "AVAILABILITY", v: "IMMEDIATE", hot: true },
      ],
      logTitle: "FIELD.LOG // EXPERIENCE",
      log: [
        { k: "ARES ELETTRONICA S.R.L.", d: "2023", v: "Control panel assembly & wiring for industrial cranes, functional testing" },
        { k: "ITALVISION", d: "2024", v: "Machine-vision quality systems: configuration & testing" },
        { k: "NORTH SAILS", d: "2024 — 2025", v: "Inventory management & customer care" },
        { k: "FOOT LOCKER", d: "2025 — 2026", v: "Sales goals & team collaboration" },
      ],
    },
    skills: {
      label: "02 // TOOLBOX",
      title: "SYSTEMS I WORK WITH",
      sub: "One platform, mastered end to end — hardware wiring to operator screens.",
      termTitle: "SYS.MONITOR",
      term: [
        "CPU S7-1512C ... ONLINE",
        "STATE: RUN",
        "CYCLE TIME: 2.4 MS",
        "DIAGNOSTICS: NO FAULTS",
        "I/O: 416 / 416 ... OK",
      ],
      groups: [
        { title: "PLC & LANGUAGES", items: ["LADDER", "SCL", "FBD", "GRAPH", "S7-1500", "S7-1200", "ABB (ADV. CERT.)"] },
        { title: "HMI & VISUALIZATION", items: ["KTP700 BASIC", "WINCC", "HMI INTERFACES", "VISION SYSTEMS"] },
        { title: "ELECTRICAL & FIELD", items: ["ELECTRICAL DIAGRAMS", "PANEL WIRING", "FUNCTIONAL TESTING", "MACHINE SAFETY"] },
        { title: "DIAGNOSTICS & METHODS", items: ["SYSTEM DIAGNOSTICS", "PROBLEM SOLVING", "ANALOG SCALING", "PID (P/PI)"] },
        { title: "TOOLS", items: ["TIA PORTAL V17", "PLCSIM", "PLANT SIMULATION"] },
      ],
    },
    projects: {
      label: "03 // SELECTED WORK",
      title: "TIA PORTAL PROJECTS",
      sub: "Two full plants developed exercise by exercise in TIA Portal: a pasta factory dosing plant and an automated galvanizing plant. Every archive and the full documentation are downloadable.",
      prj: "PRJ",
      open: "OPEN PROJECT",
      download: "DOWNLOAD",
      noDocs: "DOCS ON REQUEST",
      close: "CLOSE",
      techLabel: "STACK //",
      loading: "LOADING PROJECT DB ...",
      attachments: "ATTACHMENTS",
      empty: "NO PROJECTS YET — CHECK BACK SOON",
    },
    contact: {
      label: "04 // CONTACT",
      title: "LET'S PUT YOUR LINE IN RUN.",
      sub: "Looking for a junior PLC programmer? Tell me about your plant, your machines or your project — I answer fast.",
      form: { name: "NAME", email: "EMAIL", message: "MESSAGE", send: "SEND MESSAGE", sending: "TRANSMITTING ..." },
      sent: "> MSG RECEIVED // I'LL GET BACK WITHIN 24H",
      direct: "DIRECT LINES",
      emailVal: "kalebbbusiness@gmail.com",
      phone: "+39 392 738 7340",
      cvBtn: "DOWNLOAD CV",
      meta: [
        { k: "RESPONSE TIME", v: "< 24 HOURS" },
        { k: "LANGUAGES", v: "IT / EN — C2" },
        { k: "LOCATION", v: "REGGIO EMILIA, IT" },
        { k: "WORK MODE", v: "ON-SITE / REMOTE" },
      ],
    },
    footer: {
      tagline: "ALL SYSTEMS OPERATIONAL",
      admin: "ADMIN",
      built: "HAND-CODED // NO TEMPLATE",
    },
  },
  it: {
    name: "CALEB DEMISEW ZELEKE",
    role: "PROGRAMMATORE PLC",
    nav: { about: "CHI SONO", skills: "COMPETENZE", projects: "PROGETTI", contact: "CONTATTI", cta: "PARLIAMO" },
    hero: {
      eyebrow: "SYS.STATUS // DISPONIBILE",
      lines: ["LOGICA CHE", "MUOVE", "FABBRICHE."],
      sub: "Programmatore PLC con diploma in Automazione Industriale, specializzato in Siemens TIA Portal. Determinato e preciso — pronto a dare vita alla logica sul piano di fabbrica.",
      ctaProjects: "VEDI PROGETTI",
      ctaContact: "CONTATTAMI",
      cvBtn: "SCARICA CV",
      fig: "FIG.01 — QUADRO ELETTRICO / COLLAUDO",
      term: [
        { k: "PIATTAFORMA", v: "TIA PORTAL V17" },
        { k: "CPU", v: "SIMATIC S7-1512C" },
        { k: "STATO", v: "RUN", hot: true },
        { k: "MODO", v: "IN CAMPO / REMOTO" },
      ],
      scroll: "SCROLL",
    },
    marquee: ["SIEMENS TIA PORTAL", "LADDER LOGIC", "SCL", "S7-1500", "PROGETTAZIONE HMI", "PROFINET", "SCADA", "MOTION CONTROL", "WINCC", "COLLAUDI"],
    about: {
      label: "01 // CHI SONO",
      title: "LO SCL È LA MIA LINGUA.",
      p1: "Sono un tecnico dell'automazione industriale con diploma in Elettronica ed Elettrotecnica (Articolazione Automazione) all'I.I.S. Enrico Fermi di Modena. Programmo PLC in Siemens TIA Portal — Ladder e SCL — e ho maturato esperienza pratica cablando quadri elettrici per gru industriali e collaudando sistemi di visione artificiale per il controllo qualità durante gli stage.",
      p2: "Sono determinato e preciso, con una forte volontà di apprendere e crescere professionalmente. Mi piacciono i programmi che il prossimo tecnico sa leggere: struttura dei blocchi pulita, commenti onesti, diagnostica che aiuta davvero.",
      p3: "Disponibile per assunzioni a tempo pieno e posizioni junior nel mondo dell'automazione industriale.",
      cvBtn: "SCARICA CV",
      tags: ["LADDER", "SCL", "HMI", "SCHEMI ELETTRICI", "SICUREZZA MACCHINE", "PROBLEM SOLVING"],
      fig: "FIG.02 — IN CAMPO",
      status: [
        { k: "SPECIALIZZAZIONE", v: "SIEMENS TIA PORTAL" },
        { k: "ISTRUZIONE", v: "IIS ENRICO FERMI — MODENA" },
        { k: "CERTIFICAZIONE", v: "PROGRAMMAZIONE ABB AVANZATA" },
        { k: "LINGUE", v: "IT / EN — C2" },
        { k: "SEDE", v: "REGGIO EMILIA, IT" },
        { k: "DISPONIBILITÀ", v: "IMMEDIATA", hot: true },
      ],
      logTitle: "FIELD.LOG // ESPERIENZE",
      log: [
        { k: "ARES ELETTRONICA S.R.L.", d: "2023", v: "Assemblaggio e cablaggio quadri elettrici per gru industriali, collaudo" },
        { k: "ITALVISION", d: "2024", v: "Sistemi di visione artificiale per il controllo qualità: configurazione e collaudo" },
        { k: "NORTH SAILS", d: "2024 — 2025", v: "Gestione inventario & assistenza clienti" },
        { k: "FOOT LOCKER", d: "2025 — 2026", v: "Obiettivi di vendita & collaborazione di squadra" },
      ],
    },
    skills: {
      label: "02 // TOOLBOX",
      title: "SISTEMI CON CUI LAVORO",
      sub: "Un'unica piattaforma, padroneggiata dal cablaggio alle schermate operatore.",
      termTitle: "SYS.MONITOR",
      term: [
        "CPU S7-1512C ... ONLINE",
        "STATO: RUN",
        "TEMPO CICLO: 2.4 MS",
        "DIAGNOSTICA: NESSUN ERRORE",
        "I/O: 416 / 416 ... OK",
      ],
      groups: [
        { title: "PLC & LINGUAGGI", items: ["LADDER", "SCL", "FBD", "GRAPH", "S7-1500", "S7-1200", "ABB (CERT. AV.)"] },
        { title: "HMI & VISUALIZZAZIONE", items: ["KTP700 BASIC", "WINCC", "INTERFACCE HMI", "SISTEMI DI VISIONE"] },
        { title: "ELETTRICA & CAMPO", items: ["SCHEMI ELETTRICI", "CABLAGGIO QUADRI", "COLLAUDI", "SICUREZZA MACCHINE"] },
        { title: "DIAGNOSTICA & METODI", items: ["DIAGNOSTICA SISTEMI", "PROBLEM SOLVING", "SCALING ANALOGICO", "PID (P/PI)"] },
        { title: "STRUMENTI", items: ["TIA PORTAL V17", "PLCSIM", "SIMULAZIONE IMPIANTI"] },
      ],
    },
    projects: {
      label: "03 // LAVORI SELEZIONATI",
      title: "PROGETTI TIA PORTAL",
      sub: "Due impianti completi sviluppati esercizio per esercizio in TIA Portal: un impianto di dosaggio per pastificio e un impianto di zincatura automatizzato. Ogni archivio e la documentazione completa sono scaricabili.",
      prj: "PRJ",
      open: "APRI PROGETTO",
      download: "SCARICA",
      noDocs: "DOC SU RICHIESTA",
      close: "CHIUDI",
      techLabel: "STACK //",
      loading: "CARICAMENTO DATABASE PROGETTI ...",
      attachments: "ALLEGATI",
      empty: "NESSUN PROGETTO — TORNA PRESTO",
    },
    contact: {
      label: "04 // CONTATTI",
      title: "METTIAMO LA TUA LINEA IN RUN.",
      sub: "Cerchi un programmatore PLC junior? Raccontami del tuo impianto, delle tue macchine o del tuo progetto — rispondo in fretta.",
      form: { name: "NOME", email: "EMAIL", message: "MESSAGGIO", send: "INVIA MESSAGGIO", sending: "TRASMISSIONE ..." },
      sent: "> MESSAGGIO RICEVUTO // RISPONDO ENTRO 24H",
      direct: "LINEE DIRETTE",
      emailVal: "kalebbbusiness@gmail.com",
      phone: "+39 392 738 7340",
      cvBtn: "SCARICA CV",
      meta: [
        { k: "TEMPO DI RISPOSTA", v: "< 24 ORE" },
        { k: "LINGUE", v: "IT / EN — C2" },
        { k: "SEDE", v: "REGGIO EMILIA, IT" },
        { k: "MODO DI LAVORO", v: "IN CAMPO / REMOTO" },
      ],
    },
    footer: {
      tagline: "TUTTI I SISTEMI OPERATIVI",
      admin: "ADMIN",
      built: "SCRITTO A MANO // NESSUN TEMPLATE",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  const change = (l) => {
    setLang(l);
    localStorage.setItem("lang", l);
    document.documentElement.lang = l;
  };
  return <I18nContext.Provider value={{ lang, setLang: change, t: dict[lang] }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export const bi = (lang, obj, field) => {
  if (!obj) return "";
  const k = `${field}_${lang}`;
  return obj[k] || obj[`${field}_en`] || obj[`${field}_it`] || "";
};
